"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _Icon = _interopRequireDefault(require("../../../common/Icon"));

var _Slider = _interopRequireDefault(require("../../../common/Slider"));

var _Button = _interopRequireDefault(require("../../../common/Button"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _components = _interopRequireDefault(require("../../../styles/components"));

var _Badge = _interopRequireDefault(require("../../../common/Badge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media, {
    queries: state.query
  });
};

var PrimaryControls = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PrimaryControls, _React$PureComponent);

  function PrimaryControls() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var onPlay = _this.props.onPlay;
      onPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      var onPause = _this.props.onPause;
      onPause();
    });

    _defineProperty(_assertThisInitialized(_this), "skipForward", function () {
      var _this$props = _this.props,
          onSeek = _this$props.onSeek,
          duration = _this$props.duration,
          currentTime = _this$props.currentTime;
      var skipTime = currentTime + 15000; // currentTime + (duration / 20);

      onSeek({
        s: skipTime > duration ? duration : skipTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipBackward", function () {
      var _this$props2 = _this.props,
          onSeek = _this$props2.onSeek,
          duration = _this$props2.duration,
          currentTime = _this$props2.currentTime;
      var skipTime = currentTime - 15000; // currentTime - (duration / 20);

      onSeek({
        s: skipTime < 0 ? 0 : skipTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipToNextHit", function (event) {
      var _this$props3 = _this.props,
          queries = _this$props3.queries,
          currentTime = _this$props3.currentTime,
          onSeek = _this$props3.onSeek;

      var hits = _this.getHits(queries);

      var hit = hits.find(function (hit) {
        return hit.s > Math.ceil(currentTime);
      }) || hits[0];

      if (hit) {
        onSeek(hit);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeVolume", function (value) {
      var onVolume = _this.props.onVolume;
      onVolume(value / 100);
    });

    _defineProperty(_assertThisInitialized(_this), "getHits", (0, _memoizeOne["default"])(function (queries) {
      var _ref;

      return (_ref = []).concat.apply(_ref, queries.map(function (query) {
        return query.hits;
      })).sort(function (a, b) {
        return a.s - b.s;
      });
    }));

    return _this;
  }

  var _proto = PrimaryControls.prototype;

  _proto.render = function render() {
    var _agentDetail$extended, _agentDetail$extended2, _agentDetail$extended3, _agentDetail$extended4, _agentDetail$callDeta, _agentDetail$callDeta2;

    var _this$props4 = this.props,
        volume = _this$props4.volume,
        paused = _this$props4.paused,
        bookmarks = _this$props4.bookmarks,
        readyState = _this$props4.readyState,
        _this$props4$currentT = _this$props4.currentTime,
        currentTime = _this$props4$currentT === void 0 ? 0 : _this$props4$currentT,
        _this$props4$duration = _this$props4.duration,
        duration = _this$props4$duration === void 0 ? 0 : _this$props4$duration,
        queries = _this$props4.queries,
        agentDetail = _this$props4.agentDetail,
        mediaId = _this$props4.mediaId;
    var loading = readyState < 2;
    var agentExtendedName = "" + ((agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended = agentDetail.extended) === null || _agentDetail$extended === void 0 ? void 0 : _agentDetail$extended.agent_first_name) ? (agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended2 = agentDetail.extended) === null || _agentDetail$extended2 === void 0 ? void 0 : _agentDetail$extended2.agent_first_name) + " " : "") + ((agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended3 = agentDetail.extended) === null || _agentDetail$extended3 === void 0 ? void 0 : _agentDetail$extended3.agent_last_name) ? agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended4 = agentDetail.extended) === null || _agentDetail$extended4 === void 0 ? void 0 : _agentDetail$extended4.agent_last_name : "");
    var agentName = agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$callDeta = agentDetail.callDetails) === null || _agentDetail$callDeta === void 0 ? void 0 : (_agentDetail$callDeta2 = _agentDetail$callDeta.agent) === null || _agentDetail$callDeta2 === void 0 ? void 0 : _agentDetail$callDeta2.fullName;
    var parsedDate = (agentDetail === null || agentDetail === void 0 ? void 0 : agentDetail.parsedDate) || (agentDetail === null || agentDetail === void 0 ? void 0 : agentDetail.startTime);
    var name = agentName || agentExtendedName;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControls, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControlTitle, null, name ? /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: "400"
      }
    }, "Agent: ") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), agentName || agentExtendedName || "No agent details")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControlTitle, null, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: "400"
      }
    }, "Media ID: "), mediaId)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControlSubTitle, null, parsedDate ? "on " + parsedDate : "")));
  };

  return PrimaryControls;
}(_react["default"].PureComponent);

_defineProperty(PrimaryControls, "defaultProps", {
  queries: []
});

PrimaryControls.propTypes = process.env.NODE_ENV !== "production" ? {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  paused: _propTypes["default"].bool,
  bookmarks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number
  }))
} : {};

var _default = (0, _connectToMedia["default"])(mapStateToProps)(PrimaryControls);

exports["default"] = _default;